import React, { useCallback, useEffect, useMemo, useState } from "react";

import { updateSiteHistory } from "app/_services/UserManagement/EmployeeService";
import { Modal, Button } from "react-bootstrap";
import { confirmAlert } from "react-confirm-alert";
import toastr from "toastr";
import SearchBootstrapTable from "app/Components/BootstrapTable/SearchBootstrapTable";
import CustomTooltip from "app/Components/CommanComponents/CustomTooltip";
import { FiEdit3 } from "react-icons/fi";
import EmployeeSiteHistoryForm from "./EmployeeSiteHistoryForm";
import {
  employeeFormLabel,
  initialMedicalValidation,
  initialTrainingValidation,
} from "../Constant";
import { isAfter } from "app/_helpers/dateHelper";
import InitialLocationForm from "./InitialLocationForm";
import { contractorPersonFormLabel } from "../../ContractorPerson/Constant";
import ConfirmationModal from "./ConfimationModal";
import NetZeroLoader from "app/views/custom/components/Loader/NetZeroLoader";
function LocationHistoryList({
  data,
  getFormData,
  siteList,
  employeeType,
  contractorList = [],
  showContractor,
  isContractorPerson,
}) {
  const [siteHistoryList, setSiteHistoryList] = useState([]);

  // Edit Site History Modal
  const [editHistory, setEditHistory] = useState(false);
  const [selectedHistory, setSelectedHistory] = useState({});
  const [initialSelectedHistory, setInitialSelectedHistory] = useState({});
  const [historyError, setHistoryError] = useState({});
  const [isDisable, setIsDisable] = useState(false);
  const [confirmation, setConfirmation] = useState(false);
  const [confirmMsg, setConfirmMsg] = useState({});
  const [loading, setLoading] = useState(false);

  let query = "checkPreviousRecord=true";
  /******************* Site History Modal**********************/
  const onClickEditHistory = (row) => {
    setEditHistory(true);
    setSelectedHistory({
      ...row,
      siteId: row.siteId || "",
      startDate: row.startDate || "",
      endDate: row.endDate || "",
    });

    setInitialSelectedHistory({ ...row });
  };

  const onHideSiteHistory = () => {
    setSiteHistoryList([]);
  };

  const siteHistoryColumns = useMemo(() => {
    let data = [
      {
        dataField: "sid",
        text: "S.No.",
        sort: true,
      },
      {
        dataField: "siteTypeView",
        text: "Location Type",
        sort: true,
      },
      {
        dataField: "siteName",
        text: "Location",
        sort: true,
      },

      {
        dataField: "startDateView",
        text: "Start Date",
        sort: true,
      },
      {
        dataField: "endDateView",
        text: "End Date",
        sort: true,
      },
      {
        dataField: "create",
        text: "Action",
        formatter: (rowContent, row) => {
          if (
            Array.isArray(siteHistoryList) &&
            siteHistoryList.length > 0 &&
            row.id === siteHistoryList[0].id
          ) {
            return (
              <div className="actionIconsGroup">
                <CustomTooltip tooltip="Edit">
                  <span
                    onClick={() => onClickEditHistory(row)}
                    className="icons btn-icon font-20 text-cyanBlue"
                  >
                    <FiEdit3 />
                  </span>
                </CustomTooltip>
              </div>
            );
          }
        },
      },
    ];

    if (showContractor)
      data.splice(1, 0, {
        dataField: "contractorName",
        text: "Contractor Name",
        sort: true,
      });

    return data;
  }, [showContractor, siteHistoryList]);

  const showTraining = useMemo(
    () => selectedHistory.siteType === 3,
    // initialForm.siteType !== 3 &&
    // !selectedHistory?.basicTrainingCompletionDate,
    [selectedHistory.siteType]
  );

  const showMedical = useMemo(
    () =>
      selectedHistory.siteType === 3 &&
      // initialForm.siteType !== 3 &&
      !selectedHistory?.lastIMEDate,
    [selectedHistory?.lastIMEDate, selectedHistory.siteType]
  );

  useEffect(() => {
    if (!isContractorPerson) return;
    if (
      selectedHistory?.currentWorkLocation === initialSelectedHistory?.currentWorkLocation
    ) {
      setSelectedHistory((prev) => ({
        ...prev,
        trainingEligibility: initialSelectedHistory?.trainingEligibility,
        trainingDesignation: initialSelectedHistory?.trainingDesignation,
        specialMedicalExamEligibility:
          initialSelectedHistory?.specialMedicalExamEligibility,
        specialMedicalExamCategory: initialSelectedHistory?.specialMedicalExamCategory,
      }));
      setIsDisable(true);
    } else setIsDisable(false);
  }, [
    selectedHistory?.currentWorkLocation,
    initialSelectedHistory?.currentWorkLocation,
    initialSelectedHistory?.specialMedicalExamCategory,
    initialSelectedHistory?.specialMedicalExamEligibility,
    initialSelectedHistory?.trainingDesignation,
    initialSelectedHistory?.trainingEligibility,
    isContractorPerson,
  ]);

  /******************* Add Site  Modal******************/
  const onChangeHistory = ({ target: { name, value, type, checked } }) => {
    let extraToChange = {};
    if (
      name === "currentWorkLocation" &&
      value !== selectedHistory?.currentWorkLocation
    ) {
      if (
        siteList
          .filter((d) => d.siteType === 3)
          .map((d) => d.id)
          .includes(+value)
      ) {
        if (!selectedHistory?.lastIMEDate && !selectedHistory?.lastPMEDate) {
          extraToChange.mineTag = "yes";
          extraToChange.trainingEligibility = "";
          extraToChange.trainingDesignation = "";
          // extraToChange.isPmeDate = false;
          // extraToChange.pmeDate = "";
          extraToChange.specialMedicalExamEligibility = "";
          extraToChange.specialMedicalExamCategory = "";
        } else extraToChange.mineTag = "yes";
      } else {
        extraToChange.mineTag = "no";
        extraToChange.startDateAtMines = "";
      }
    }

    if (name === "siteType" && value !== selectedHistory?.siteType) {
      extraToChange.currentWorkLocation = "";
      extraToChange.startDateAtMines = "";
      extraToChange.endDateAtMines = "";
      extraToChange.mineTag = "no";
    }

    if (name === "trainingEligibility" && value !== "yes") {
      extraToChange.trainingDesignation = "";
    }

    if (name === "isPmeDate" && value !== selectedHistory?.isPmeDate) {
      extraToChange.pmeDate = "";
      extraToChange.pmeCertificateNo = "";
      extraToChange.pmeCertificateId = null;
    }

    if (name === "isIMEDate" && value !== selectedHistory?.isIMEDate) {
      extraToChange.imeDate = "";
      extraToChange.imeCertificateNo = "";
      extraToChange.imeCertificateId = null;
    }

    if (name === "specialMedicalExamEligibility" && value !== "yes") {
      extraToChange.specialMedicalExamCategory = "";
    }

    setSelectedHistory((prev) => ({
      ...prev,
      ...extraToChange,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const onHideHistory = () => {
    setEditHistory(false);
    setSelectedHistory({});
  };

  const onHideConfirmation = () => {
    setConfirmation(false);
  };

  const onSubmitEditHistory = useCallback(
    async (e, query) => {
      if (e) e.preventDefault();
      let errorObj = {};
      if (selectedHistory.siteType) {
        if (!selectedHistory.currentWorkLocation) {
          errorObj["currentWorkLocation"] =
            employeeFormLabel["currentWorkLocation"] + " is Required.";
        }

        // if (selectedHistory.currentWorkLocation) {
        if (!selectedHistory.startDateAtMines)
          errorObj["startDateAtMines"] =
            employeeFormLabel["startDateAtMines"] + " is Required.";
        // }

        if (
          selectedHistory.dateOfJoining &&
          selectedHistory.startDateAtMines &&
          isAfter(selectedHistory.dateOfJoining, selectedHistory.startDateAtMines)
        ) {
          errorObj["startDateAtMines"] =
            employeeFormLabel["startDateAtMines"] +
            " Can't Before " +
            employeeFormLabel["dateOfJoining"];
        }
      } else {
        errorObj["siteType"] = employeeFormLabel["siteType"] + " is Required.";
      }
      if (showContractor && !selectedHistory.contractorId) {
        errorObj["contractorId"] =
          contractorPersonFormLabel["contractorId"] + " is Required.";
      }
      if (showTraining) {
        errorObj = initialTrainingValidation(errorObj, selectedHistory);
      }
      if (selectedHistory?.siteType === 3) {
        errorObj = initialMedicalValidation(errorObj, selectedHistory);
      }
      setHistoryError(errorObj);
      if (Object.values(errorObj).filter((d) => d !== "").length) return;
      setLoading(true);
      let formObj = {
        employeeType: employeeType || "employee",
        employeeId: selectedHistory.id,
        siteId: selectedHistory.currentWorkLocation,
        startDate: selectedHistory.startDateAtMines,
        // endDate: selectedHistory.endDate,
        siteType: selectedHistory?.siteType,
        trainingEligibility: selectedHistory.trainingEligibility,
        trainingDesignation: selectedHistory.trainingDesignation,
        isPmeDate: selectedHistory.isPmeDate,
        pmeDate: selectedHistory.pmeDate,
        specialMedicalExamEligibility: selectedHistory.specialMedicalExamEligibility,
        specialMedicalExamCategory: selectedHistory.specialMedicalExamCategory,
        pmeCertificateNo: selectedHistory?.pmeCertificateNo,
        pmeCertificateId: selectedHistory?.pmeCertificateId,
        imeDate: selectedHistory?.imeDate,
        isIMEDate: selectedHistory?.isIMEDate,
        imeCertificateNo: selectedHistory?.imeCertificateNo,
        imeCertificateId: selectedHistory?.imeCertificateId,
      };
      if (showContractor) formObj.contractorId = selectedHistory.contractorId;
      let response = await updateSiteHistory(formObj, query);
      if (!response?.status) {
        setLoading(false);
        return toastr.error(response?.message);
      }
      console.log("ppppppppppp77777", response?.data);
      if (response?.data?.existingData) {
        setConfirmMsg(response?.data?.existingData);
        setConfirmation(true);
        setEditHistory(false);
        setLoading(false);
        return;
      } else {
        setConfirmation(false);
      }
      setLoading(false);
      toastr.success(response.message || "Success.");
      onHideHistory();
      onHideSiteHistory();
      if (getFormData) getFormData(2);
    },
    [employeeType, getFormData, selectedHistory, showContractor, showTraining]
  );
  /************** useMemo ***************/
  useEffect(() => {
    let response = JSON.parse(JSON.stringify(data));
    response.sort(function (a, b) {
      return b.id - a.id;
    });
    setSiteHistoryList(response);
  }, [data]);

  const confirmationAlert = useCallback(() => {
    confirmAlert({
      title: "Change location",
      message: "Are you sure you want to proceed with location update",
      buttons: [
        {
          label: "Yes",
          onClick: (e) => onSubmitEditHistory(e),
        },
        {
          label: "No",
          onClick: () => {
            setConfirmation(false);
          },
        },
      ],
    });
  }, [onSubmitEditHistory]);

  return (
    <div>
      {/* Site History */}
      <div className="mt-2 mb-4">
        <h5>History</h5>

        <SearchBootstrapTable
          tableName={"site-history"}
          data={siteHistoryList}
          columns={siteHistoryColumns}
          tableDownloadFlag={false}
        />
      </div>

      {/* Edit Site History Modal */}
      {!loading ? (
        <Modal
          size="lg"
          show={editHistory}
          onHide={onHideHistory}
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header closeButton>
            <Modal.Title>Edit History</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <InitialLocationForm
              siteList={siteList}
              form={selectedHistory}
              onChange={onChangeHistory}
              error={historyError}
              contractorList={contractorList}
              showContractor={showContractor}
              menuPortalTarget={null}
              showTraining={showTraining}
              showMedical={showMedical}
              isDisable={isDisable}
            />
          </Modal.Body>

          <Modal.Footer className="justify-content-center">
            <div>
              <Button variant="secondary" onClick={() => onHideHistory()}>
                Back
              </Button>
              <Button
                className="ml-2"
                onClick={(e) => {
                  onSubmitEditHistory(e, query);
                }}
                variant="primary"
              >
                Update
              </Button>
            </div>
          </Modal.Footer>
        </Modal>
      ) : (
        <NetZeroLoader addZIndex={true} />
      )}

      {/* Confirmation Modal */}
      {!loading ? (
        <ConfirmationModal
          confirmation={confirmation}
          onHideConfirmation={onHideConfirmation}
          confirmMsg={confirmMsg}
          confirmationAlert={confirmationAlert}
          title={"Location Change Confirmation"}
          type={"location"}
          modalFor={"employee"}
          checkMedicalForPending={true}
        ></ConfirmationModal>
      ) : (
        ""
      )}
    </div>
  );
}

export default LocationHistoryList;
